<div class="vigencia-campanha-form-control-radio">
    <label class="col-form-label" [for]="id">{{inputLabel}}</label>
    <br/>
    <div class="custom-control custom-radio custom-control-inline">
        <input type="radio" class="custom-control-input" [name]="name" id="{{id}}_Sim" [value]="true" [ngModel]="vigenciaRecorrente" (ngModelChange)="onChange($event)"
            #vigenciaRecorrenteModel="ngModel" [required]="required" [attr.disabled]="canEdit == false || null" [attr.readonly]="canEdit == false || null">                     
        <label class="custom-control-label" for="{{id}}_Sim">Sim</label>
    </div> 
    <div class="custom-control custom-radio custom-control-inline">
        <input type="radio" class="custom-control-input" [name]="name" id="{{id}}_Nao" [value]="false" [ngModel]="vigenciaRecorrente" (ngModelChange)="onChange($event)"
            required="required" [attr.disabled]="canEdit == false || null" [attr.readonly]="canEdit == false || null">                     
        <label class="custom-control-label" for="{{id}}_Nao">Não</label>
    </div> 
    <sgt-form-control-error
        *ngIf="vigenciaRecorrenteModel.errors && vigenciaRecorrenteModel.errors.required && vigenciaRecorrenteModel.dirty"
        [msgError]="msgRequiredError">
    </sgt-form-control-error>   
    <p class="form-text text-muted">
        {{inputHelpText}}
    </p> 
</div>